import React from "react"
import { Button, Modal } from 'react-bootstrap'
import { CardText } from 'reactstrap'

export function DeleteFolderModal(props) {
    const onDeleteConfirm = async (event) => {
        event.preventDefault()
        props.onDeleteFolder()
    }

    return (
        <Modal show={props.showModal} onHide={props.onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.hasChildren ? (
                    <CardText>
                        This folder cannot be deleted as it contains subfolders. Please remove all subfolders before attempting to delete this folder.
                    </CardText>
                ) : (
                    <CardText>
                        {`Are you sure you want to delete the folder: '${props.folderName}'? Note this action is permanent!`}
                    </CardText>
                )}
            </Modal.Body>
            <Modal.Footer>
                {!props.hasChildren && (
                    <Button variant='danger' onClick={onDeleteConfirm}>
                        Yes
                    </Button>
                )}
                <Button variant='secondary' onClick={props.onHide}>
                    {props.hasChildren ? 'Close' : 'Cancel'}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}